module.exports = __webpack_public_path__ + "img/kungarna-821px.6b92b714.jpg";